import { put, call, takeLatest } from 'redux-saga/effects';
import * as actions from '../../../reducers/ducks/new/Restaurant/RestaurantReducer';
import notifyBugsnag from '../../../../../util/notifyBugsnag';

import { getRestaurantDetails as apiGetRestaurantDetails } from '../../../../../util/api/RestaurantApiClient';

export function* getRestaurantDetailsSaga({ payload }) {
  try {
    const response = yield call(apiGetRestaurantDetails, payload);
    yield put(actions.setSelectedRestaurantData(response));
  } catch (err) {
    notifyBugsnag(err);
    yield put(actions.setSelectedRestaurantData(null));
  }
}

export function* watchRestaurantSagas() {
  yield takeLatest(
    actions.setSelectedRestaurantId.type,
    getRestaurantDetailsSaga
  );
}
